import React from 'react';
import { Component } from '../common/ui/Component';

export const OrderFormCartLoading = () => {
    const CartHeaderLoading = () => {
        return (
            <li className="list-group-item">
                <div className="row">
                    <div className="col-lg-1 col-xl-1"></div>
                    <div className="placeholder-glow col d-block d-lg-none">
                        <span className="placeholder w-100 mt-1 mb-2"></span>
                    </div>
                    <div className="placeholder-glow d-none d-lg-block col-lg-3 col-xl-4 d-flex justify-content-between">
                        <span className="placeholder placeholder-lg w-100 my-2"></span>
                    </div>
                    <div className="placeholder-glow d-none d-lg-block col-lg-2 col-xl-2 d-flex justify-content-between">
                        <span className="placeholder placeholder-lg w-100 my-2"></span>
                    </div>
                    <div className="placeholder-glow d-none d-lg-block col-lg-3 col-xl-3 d-flex justify-content-between">
                        <span className="placeholder placeholder-lg w-100 my-2"></span>
                    </div>
                    <div className="placeholder-glow d-none d-lg-block col-lg-3 col-xl-2 d-flex justify-content-between">
                        <span className="placeholder placeholder-lg w-100 my-2"></span>
                    </div>
                </div>
            </li>
        );
    };

    const CartItemLoading = () => {
        return (
            <li className="list-group-item">
                <div className="row">
                    <div className="col-lg-1 col-xl-1">
                        <p className="text-center text-secondary mt-3 mt-md-0 mb-0">
                            <svg
                                className="bd-placeholder-img"
                                width="32"
                                height="32"
                                xmlns="http://www.w3.org/2000/svg"
                                role="img"
                                aria-label="Placeholder"
                                preserveAspectRatio="xMidYMid slice"
                                focusable="false">
                                <title>Placeholder</title>
                                <rect width="100%" height="100%" fill="#C4C8CB"></rect>
                            </svg>
                        </p>
                    </div>
                    <div className="placeholder-glow col-lg-3 col-xl-4 d-flex justify-content-between">
                        <span className="placeholder placeholder-sm col-3 d-block d-lg-none my-2 me-3"></span>
                        <span className="placeholder placeholder-lg col my-2"></span>
                    </div>
                    <div className="placeholder-glow col-lg-2 col-xl-2 d-flex justify-content-between">
                        <span className="placeholder placeholder-sm col-3 d-block d-lg-none my-2 me-3"></span>
                        <span className="placeholder placeholder-lg col my-2"></span>
                    </div>
                    <div className="placeholder-glow col-lg-3 col-xl-3 d-flex justify-content-between">
                        <span className="placeholder placeholder-sm col-3 d-block d-lg-none my-2 me-3"></span>
                        <span className="placeholder placeholder-lg col my-2"></span>
                    </div>
                    <div className="placeholder-glow col-lg-3 col-xl-2 d-flex justify-content-between">
                        <span className="placeholder placeholder-sm col-3 d-block d-lg-none my-2 me-3"></span>
                        <span className="placeholder placeholder-lg col my-2"></span>
                    </div>
                </div>
            </li>
        );
    };

    const CartFooterLoading = () => {
        return (
            <li className="placeholder-glow list-group-item">
                <div className="d-flex align-items-center justify-content-between">
                    <span className="placeholder placeholder-sm col-3 me-3"></span>
                    <div className="d-grid col-2">
                        <span className="btn btn-primary disabled placeholder mb-2"></span>
                    </div>
                </div>
            </li>
        );
    };

    return (
        <ul className="list-group">
            <CartHeaderLoading />
            <Component size={3} element={CartItemLoading} />
            <CartFooterLoading />
        </ul>
    );
};
